// Intl Util
import IntlPolyfill from 'intl'
import _ from 'lodash'
import { addLocaleData, defineMessages } from 'react-intl'
import en from 'react-intl/locale-data/en'
import nl from 'react-intl/locale-data/nl'
import de from 'react-intl/locale-data/de'

import localeEn from '../locale/en.json'
import localeNl from '../locale/nl.json'
import localeDe from '../locale/de.json'
import localeUs from '../locale/us.json'

import consoleLocaleEn from '../locale/console_en.json'
import consoleLocaleNl from '../locale/console_nl.json'
import consoleLocaleDe from '../locale/console_de.json'
import consoleLocaleUs from '../locale/console_us.json'

let _intl = null
let _lang = 'en'

function _setup (lang) {
  if (!window.Intl) {
    window.Intl = IntlPolyfill
  } else {
    window.Intl.NumberFormat = IntlPolyfill.NumberFormat
    window.Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat
  }

  if (lang === 'nl') {
    addLocaleData([...nl])
  }
  if (lang === 'de') {
    addLocaleData([...de])
  } else {
    addLocaleData([...en])
  }

  _lang = lang
}

function _loadMessages () {
  const messages = {}

  _loadTranslatedMessage(messages, _lang)
  return defineMessages(messages)
}

function _loadConsoleMessages () {
  const messages = {}

  _loadConsoleTranslatedMessage(messages, _lang)
  return defineMessages(messages)
}

function _loadMessage (langMessages, ident, messages) {
  for (const group of Object.keys(messages)) {
    const groupMsgs = messages[group]
    for (const id of Object.keys(groupMsgs)) {
      const key = `${ident}.${group}.${id}`
      langMessages[key] = groupMsgs[id]
    }
  }
}

function _loadConsoleTranslatedMessage (langMessages, lang) {
  let transMsgs = null
  if (lang === 'de') {
    transMsgs = consoleLocaleDe
  } else if (lang === 'nl') {
    transMsgs = consoleLocaleNl
  } else if (lang === 'us') {
    transMsgs = consoleLocaleUs
  } else {
    transMsgs = consoleLocaleEn
  }

  _.forEach(transMsgs, function (msgs, ident) {
    _loadMessage(langMessages, ident, msgs)
  })
}

function _loadTranslatedMessage (langMessages, lang) {
  let transMsgs = null
  if (lang === 'de') {
    transMsgs = localeDe
  } else if (lang === 'nl') {
    transMsgs = localeNl
  } else if (lang === 'us') {
    transMsgs = localeUs
  } else {
    transMsgs = localeEn
  }

  _.forEach(transMsgs, function (msgs, ident) {
    _loadMessage(langMessages, ident, msgs)
  })
}

function _getBrowserLanguage () {
  let lang = ''

  if (navigator.languages) {
    lang = navigator.languages[0]
  } else if (navigator.userLanguage) {
    // IE only
    lang = navigator.userLanguage
  } else {
    // firefox + safari
    lang = navigator.language
  }

  if (lang !== '') {
    const brwLang = lang.split('-')
    return brwLang[0]
  }

  return 'en'
}

function _setIntl (intlVal) {
  _intl = intlVal
}

function _getIntl () {
  return _intl
}

function _getLang () {
  return _lang
}

function _convertMessage (ident, object = {}) {
  if (_intl) {
    return _intl.formatMessage({ id: ident }, object)
  }
  return ident
}

function _convertMessageByLanguage (lang, ident) {
  let messages = localeEn
  if (lang === 'nl') {
    messages = localeNl
  } else if (lang === 'de') {
    messages = localeDe
  } else if (lang === 'us') {
    messages = localeUs
  }

  const varNames = ident.split('.')
  let translatedValue = ''
  if (varNames.length > 0) {
    translatedValue = messages
    varNames.map((varName) => {
      translatedValue = translatedValue ? translatedValue[varName] : ''
    })
  }

  return translatedValue || ''
}

function _getFirstPhaseTitle () {
  return _convertMessage('common.list.firstphase')
}

function _getIntlProviderLanguage () {
  return _lang === 'us' ? 'en-US' : _lang
}

const IntlUtil = {
  setup: _setup,
  setIntl: _setIntl,
  getIntl: _getIntl,
  getLang: _getLang,
  convertMessage: _convertMessage,
  convertMessageByLanguage: _convertMessageByLanguage,
  getBrowserLanguage: _getBrowserLanguage,
  loadMessages: _loadMessages,
  loadConsoleMessages: _loadConsoleMessages,
  getFirstPhaseTitle: _getFirstPhaseTitle,
  getIntlProviderLanguage: _getIntlProviderLanguage
}

export default IntlUtil
